/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './list_importable_external_bank_accounts';
import './import_external_bank_account';
import './link_external_bank_account';
import './list_external_bank_accounts';
import './create_plaid_link_token';
import './link_external_bank_account_with_plaid';
import './get_plaid_link';
import './fail_plaid_link';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ExternalBankAccountService": {
                    "methods": {
                      "ListImportableExternalBankAccounts": {
                        "requestType": "squareup.sfs.external.service.ListImportableExternalBankAccountsRequest",
                        "responseType": "squareup.sfs.external.service.ListImportableExternalBankAccountsResponse"
                      },
                      "ImportExternalBankAccount": {
                        "requestType": "squareup.sfs.external.service.ImportExternalBankAccountRequest",
                        "responseType": "squareup.sfs.external.service.ImportExternalBankAccountResponse"
                      },
                      "LinkExternalBankAccount": {
                        "requestType": "squareup.sfs.external.service.LinkExternalBankAccountRequest",
                        "responseType": "squareup.sfs.external.service.LinkExternalBankAccountResponse"
                      },
                      "ListExternalBankAccounts": {
                        "requestType": "squareup.sfs.external.service.ListExternalBankAccountsRequest",
                        "responseType": "squareup.sfs.external.service.ListExternalBankAccountsResponse"
                      },
                      "CreatePlaidLinkToken": {
                        "requestType": "squareup.sfs.external.service.CreatePlaidLinkTokenRequest",
                        "responseType": "squareup.sfs.external.service.CreatePlaidLinkTokenResponse"
                      },
                      "LinkExternalBankAccountWithPlaid": {
                        "requestType": "squareup.sfs.external.service.LinkExternalBankAccountWithPlaidRequest",
                        "responseType": "squareup.sfs.external.service.LinkExternalBankAccountWithPlaidResponse"
                      },
                      "GetPlaidLink": {
                        "requestType": "squareup.sfs.external.service.GetPlaidLinkRequest",
                        "responseType": "squareup.sfs.external.service.GetPlaidLinkResponse"
                      },
                      "FailPlaidLink": {
                        "requestType": "squareup.sfs.external.service.FailPlaidLinkRequest",
                        "responseType": "squareup.sfs.external.service.FailPlaidLinkResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.ExternalBankAccountService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for importing, linking, and unlinking external bank accounts
 * --
 *
 * SOURCE ExternalBankAccountService @ squareup/sfs/external/services/external_bank_account/external_bank_account_service.proto at 18:1
 */
export const ExternalBankAccountService = $root.lookupService('squareup.sfs.external.service.ExternalBankAccountService');